import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { Spinner } from '@components/index';

const LeadDetailsEmptyState = ({
  isLoading,
  error
}: {
  isLoading: boolean;
  error: FetchBaseQueryError | SerializedError | undefined;
}) => {
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg text-red-600">
          Error loading lead details. Please try again.
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-lg">Lead not found</div>
    </div>
  );
};

export default LeadDetailsEmptyState;
